import { useMemo } from 'react';
import { QUERY_STRING } from 'providers/useSearch/SearchContext';

interface URLParamsResult {
    searchQuery: string | null;
    isAdvanced: boolean;
    isSearch: boolean;
    isHomeOrFavorites: boolean;
    isValidSearchQuery: boolean;
    isRentals: boolean;
}

/**
 * Hook to handle URL-based states and search query validation
 */

export const useURLParams = (): URLParamsResult =>
    useMemo(() => {
        const searchQuery = new URLSearchParams(window.location.search).get(QUERY_STRING);
        const path = window.location.pathname.toLowerCase();

        const isSearch = path.includes('search');

        return {
            searchQuery,
            isAdvanced: ['kids', 'lastele', 'детям'].some((term) => path.includes(term)),
            isSearch,
            isHomeOrFavorites: !path || path === '/',
            isValidSearchQuery: !isSearch || (searchQuery?.length ?? 0) >= 3,
            isRentals: ['rentals', 'laenutus', 'прокат'].some((term) => path.includes(term)),
        };
    }, [window.location.search, window.location.pathname]);
